const randomNumber = function () {
  const number = Math.floor(Math.random() * 1000000);
  return number;
};

export default randomNumber;
